import Api from "@/services/Api";
import helpers from "@/helpers.js";
import { getProductFormLookups } from "@/services/productFormLookups";

export default async function createProduct(parent_category = null) {
  const lookups = await getProductFormLookups();
  const {
    details_types,
    accessories,
    unit,
    brand,
    warranties,
    vat,
    managers,
    suppliers,
    pos_list,
    country_list,
  } = lookups;

  var products_selected_types = {};

  if (parent_category && parent_category.related_entity == "products") {
    products_selected_types[parent_category.id] = parent_category.name;
  }
  var products_selected_accessory = {};
  var is_accessory = false;
  if (parent_category && parent_category.related_entity == "accessories") {
    is_accessory = true;
    products_selected_accessory[parent_category.id] = parent_category.name;
  }

  // --- PRE-FETCH ATTRIBUTES LOGIC ---
  // If we have a parent category, fetch attributes NOW instead of waiting for the component
  var preloaded_attributes = []; // For standard products
  var preloaded_attributes_accessories = []; // For accessories

  if (parent_category) {
    try {
      // 1. Prepare the payload exactly like DaForm would
      let is_acc = parent_category.related_entity == "accessories";
      let payload = {
        field: is_acc ? "attributes_accessories" : "attributes",
        factor: is_acc ? "accessory_id" : "type_id",
        selected_options: { [parent_category.id]: parent_category.name }, // Simulate the tree-select value
      };

      // 2. Call the API manually
      let res = await Api(true).post("category/attributes", payload);

      const formatted_options = helpers.create_attributes_field(Array.isArray(res.data) ? res.data : [], parent_category.id);

      // 4. Assign to the correct variable
      if (is_acc) preloaded_attributes_accessories = formatted_options;
      else preloaded_attributes = formatted_options;
    } catch (e) {
      console.error("Autofill Attributes Error:", e);
    }
  }

  // Pre-fill next code when opened from category page (category already selected; depends_on only runs on change)
  // NOTE: Automatic code generation is temporarily disabled so that code is entered manually.
  // The block below is kept for future re-enable.
  var initialCode = "";
  // if (parent_category && (parent_category.related_entity === "products" || parent_category.related_entity === "accessories")) {
  //   try {
  //     const categoryId = parent_category.id || parent_category.guid;
  //     const res = await Api(true).post("product/next-code", { category_id: categoryId });
  //     if (res.data && res.data.code != null) initialCode = res.data.code;
  //   } catch (e) {
  //     console.error("Next code prefill Error:", e);
  //   }
  // }
  // ----------------------------------

  // Pre-fill manager from category (or its ancestors) when opened from catalog
  var initialManager = null;
  if (parent_category && (parent_category.related_entity === "products" || parent_category.related_entity === "accessories")) {
    try {
      const categoryId = parent_category.id || parent_category.guid;
      const res = await Api(true).post("category/manager", { category_id: categoryId });
      if (res.data && res.data.manager != null && res.data.manager !== 0) initialManager = res.data.manager;
    } catch (e) {
      console.error("Category manager prefill Error:", e);
    }
  }

  // Default VAT to 20% (hidden field)
  var defaultVat20 = vat.find((x) => Number(x.value) === 20 || String(x.label || x.value || "").includes("20"));
  var defaultVatId = defaultVat20 ? defaultVat20.id : (vat[0] ? vat[0].id : null);

  return {
    name: "Krijo Produkt",
    submit: [
      {
        label: "Krijo",
        action: "submitProduct",
        close_on_submit: true,
        style: "daform-submit-btn--create",
      },
      {
        label: "Krijo dhe Qendro",
        action: "submitProductAndStay",
        close_on_submit: false,
        reset_fields: ["code", "name", "model", "product_images"],
        style: "daform-submit-btn--stay",
      },
      {
        label: "Krijo dhe Kopjo",
        action: "submitProductAndCopy",
        close_on_submit: false,
        reset_fields: ["code", "name", "model", "product_images"],
        style: "daform-submit-btn--copy",
      },
    ],
    fields: [
      // 1. Type: product vs accessory | Status (top right)
      [
        { value: "", name: "is_recipe", label: "I perbere", style: "min-width: 2%; display:none;", type: "checkbox-field" },
        { value: is_accessory ? 1 : 0, name: "is_accessory", label: "Aksesor", type: "checkbox-field", style: "min-width: 2%; margin-top: 5px;", readonly: false, disabled: false },
        { value: "", name: "stock_limit", label: "Limiti i stokut", type: "number-field", style: "min-width: 15%; display: none !important;" },
        { name: "status", label: "Aktiv", type: "checkbox-field", style: "min-width: 24%; margin-top: 5px; margin-left: auto;", value: 0 },
      ],
      // 2. Category (first so code/attributes make sense)
      [
        { name: "type_id", label: "Kategoria e produktit", type: "tree-select", style: "min-width: 100%", options: details_types, selected_options: products_selected_types, mode: "single", required: true, required_text: "E detyrueshme", vif: [{ field: "is_accessory", value_not: 1 }] },
      ],
      [
        { name: "accessory_id", label: "Kategoria e aksesoreve", type: "tree-select", style: "min-width: 100%", options: accessories, selected_options: products_selected_accessory, mode: "single", required: true, required_text: "E detyrueshme", vif: [{ field: "is_accessory", value_not: 0 }] },
      ],
      // 3. Identity: code, name, model
      [
        {
          value: initialCode,
          name: "code",
          label: "Kodi",
          type: "text-field",
          style: "min-width: 24%",
          required: true,
          required_text: "E detyrueshme",
          left_icon: "fa-solid fa-hashtag",
          uppercase: true,
          // Automatic code (product/next-code) temporarily disabled; to re-enable, restore the properties below.
          // readonly: true,
          // disabled: true,
          // depends_on: "type_id",
          // api_call: "product/next-code",
        },
        { value: "", name: "name", label: "Emri", type: "text-field", style: "min-width: 45%", required: true, required_text: "E detyrueshme" },
        { value: "", name: "model", label: "Modeli", type: "text-field", style: "min-width: 29%", required: true, required_text: "E detyrueshme", unique: { model: "product", field: "model", where: [] } },
      ],
      // 4. Images
      [
        {
          name: "product_images",
          label: "Fotot e Produktit (Detyrueshme)",
          type: "image-upload",
          style: "min-width: 100%",
          required: true,
          required_text: "Ngarko të paktën një foto të produktit",
          value: [],
        },
      ],
      // 5. Description & warranty
      [
        { name: "unit", label: "Njesia", type: "select-field", style: "min-width: 24%; display: none !important;", options: unit, value: unit[0] ? unit[0].id : null, required: true },
        { value: "", name: "description", label: "Pershkrimi", type: "text-field", style: "min-width: 45%", required: false, requiredWhenActive: true, required_text: "E detyrueshme" },
        { value: "", name: "warranty_id", label: "Garancia", type: "select-field", options: warranties, style: "min-width: 29%", required: false, requiredWhenActive: true, required_text: "E detyrueshme" },
      ],
      // 6. Brand (selection left, checkbox right)
      [
        { name: "brand", label: "Zgjidh Marken", type: "tree-select", style: "min-width: 80%", options: brand, selected_options: {}, mode: "single", send_label: true, required: true, vif: [{ field: "is_new_brand", value_not: 1 }] },
        { name: "is_new_brand", label: "Shto Marke te re?", type: "checkbox-field", style: "min-width: 15%; margin-top: 5px;", value: 0 },
        { name: "new_brand_name", label: "Shkruaj emrin e Markes se re", type: "text-field", style: "min-width: 80%", required: true, vif: [{ field: "is_new_brand", value_not: 0 }] },
      ],
      // 7. Supplier (code auto-fills name; checkbox to create new with code + name)
      [
        { value: "", name: "supplier_code", label: "Kodi i furnitorit", type: "text-field", style: "min-width: 24%", uppercase: true, left_icon: "fa-solid fa-hashtag", required: false, requiredWhenActive: true, required_text: "E detyrueshme", vif: [{ field: "is_new_supplier", value_not: 1 }] },
        { name: "supplier", label: "Furnitori", type: "tree-select", style: "min-width: 56%", options: suppliers, selected_options: {}, mode: "single", send_label: true, required: false, requiredWhenActive: true, required_text: "E detyrueshme", vif: [{ field: "is_new_supplier", value_not: 1 }] },
        { name: "is_new_supplier", label: "Shto Furnitor te ri?", type: "checkbox-field", style: "min-width: 15%; margin-top: 5px;", value: 0 },
        { name: "new_supplier_code", label: "Kodi i Furnitorit te ri", type: "text-field", style: "min-width: 35%", required: true, vif: [{ field: "is_new_supplier", value_not: 0 }] },
        { name: "new_supplier_name", label: "Emri i Furnitorit te ri", type: "text-field", style: "min-width: 45%", required: true, vif: [{ field: "is_new_supplier", value_not: 0 }] },
      ],
      // 8. Pricing
      [
        { name: "old_code", label: "Kodi i vjetër", type: "text-field", style: "min-width: 100%; display: none !important;", required: false },
      ],
      [
        { name: "default_price", type: "number-field", label: "Cmimi baze", style: "min-width: 32%", required: false, requiredWhenActive: true, required_text: "E detyrueshme", format: "accounting" },
        { name: "has_offer_price", label: "Ka cmim ofertë", type: "checkbox-field", style: "min-width: 15%; margin-top: 5px;", value: 0 },
        { name: "price", label: "Cmimi ofertë", type: "number-field", style: "min-width: 32%", required: false, requiredWhenActive: true, readonly: true, disabled: true, format: "accounting" },
        { name: "vat", label: "TVSH(%)", type: "select-field", style: "min-width: 32%; display: none !important;", options: vat, value: defaultVatId },
      ],
      // 9. Identifiers
      [
        { name: "known_as", label: "Emri I njohur universal", type: "text-field", style: "min-width: 32%", required: false, requiredWhenActive: true, required_text: "E detyrueshme" },
        { name: "barcode", label: "Barkodi", type: "text-field", style: "min-width: 28%", required: true, unique: { model: "product", field: "barcode", where: [] } },
        {
          name: "generate_barcode_btn",
          label: "",
          type: "action-button",
          action: "generate_barcode",
          button_label: "Gjenero barkod",
          icon: "fa fa-barcode",
          style: "flex: 0 0 auto;",
        },
        { name: "no_barcode", label: "Pa barkod", type: "checkbox-field", style: "flex: 0 0 auto; min-width: 80px; margin-top: 5px; white-space: nowrap;", value: 0 },
      ],
      // 9a. Origin & demo version
      [
        { name: "origin", type: "select-field", label: "Direct Exchange", style: "min-width: 55%", options: country_list, required: false },
        { name: "demo_version", label: "Versioni Demo", type: "checkbox-field", style: "flex: 0 0 auto; min-width: 120px; margin-top: 5px; white-space: nowrap;", value: 0 },
      ],
      // 9b. Product segment & expiration date
      [
        {
          name: "product_segment",
          label: "Segmenti i produktit",
          type: "select-field",
          style: "min-width: 48%",
          options: [
            { id: "basic", label: "Produkt bazik" },
            { id: "medium", label: "Medium" },
            { id: "premium", label: "Premium" },
          ],
          value: null,
          required: false,
          no_placeholder: false,
        },
        {
          value: "",
          name: "expiration_date",
          label: "Date skadence",
          type: "date-field",
          style: "min-width: 48%",
          required: false,
        },
      ],
      // 10. Management (autofill from category: catalog prefill + depends_on when category changes)
      [
        { value: initialManager, name: "manager", label: "Menaxher", type: "select-field", style: "min-width: 45%", options: managers, required: false, depends_on: "type_id", api_call: "category/manager", vif: [{ field: "is_accessory", value_not: 1 }] },
        { value: initialManager, name: "manager", label: "Menaxher", type: "select-field", style: "min-width: 45%", options: managers, required: false, depends_on: "accessory_id", api_call: "category/manager", vif: [{ field: "is_accessory", value_not: 0 }] },
      ],
      // 11. Packaging & sales (Paketimi hidden)
      [
        { name: "packaging", label: "Paketimi", type: "select-field", style: "min-width: 24%; display: none !important;", options: [{ id: 0, label: "Paketim i thjeshte" }, { id: 1, label: "Kuti me 10 cope" }, { id: 2, label: "Kuti me 20 cope" }], value: 0, required: false },
        { name: "has_airbag", label: "Ka garanci Airbag", style: "min-width: 2%; margin-top:5px;", type: "checkbox-field" },
        { name: "in_web", label: "Shitet ne web", style: "min-width: 2%; margin-top:5px;", type: "checkbox-field" },
        { name: "in_store", label: "Shitet ne dyqan", style: "min-width: 2%; margin-top:5px;", type: "checkbox-field", value: 1 },
      ],
      // 11b. Web categories (read-only, derived from product category path – last 3 levels)
      [
        { name: "web_categories_display", label: "Kategoritë web (nga kategoria online e lidhur)", type: "web-categories-readonly", style: "min-width: 100%", vif: [{ field: "in_web", value: 1 }] },
      ],
      // 12. Airbag warranty
      [
        { value: 0, name: "warranty_airbag", label: "Garanci Airbag", style: "min-width: 24%", type: "select-field", options: [{ id: 0, label: "Nuk ka airbag" }, { id: 3, label: "Airbag+3" }], no_placeholder: true },
        { name: "warranty_airbag_value", type: "number-field", label: "Cmimi i airbag", style: "min-width: 45%", vif: [{ field: "warranty_airbag", value_not: 0 }] },
      ],
      // 13. Points of sale (hidden)
      [
        { name: "products_pos", label: "Poset ku mund te tregtohet ky produkt", type: "tree-select", style: "width: 100%; display: none !important;", options: pos_list, selected_options: [], mode: "multiple", required: false },
      ],
      // 14. Category attributes & services (collapsible)
      [
        { data: [], name: "attributes", label: "Atribute", type: "attributes", options: preloaded_attributes, style: "min-width: 100%", depends_on: "type_id", api_call: "category/attributes", vif: [{ field: "is_accessory", value_not: 1 }], collapsible: true, require_all: false, required: false, requiredWhenActive: true, required_text: "Të gjitha atributet janë të detyrueshme" },
        { data: [], name: "attributes_accessories", label: "Atribute", type: "attributes", options: preloaded_attributes_accessories, style: "min-width: 100%", depends_on: "accessory_id", api_call: "category/attributes", vif: [{ field: "is_accessory", value_not: 0 }], collapsible: true, require_all: false, required: false, requiredWhenActive: true, required_text: "Të gjitha atributet janë të detyrueshme" },
      ],
      [
        { data: [], name: "services", label: "Sherbime", type: "attributes", options: [], style: "min-width: 100%", depends_on: "type_id", api_call: "category/services", collapsible: true },
      ],
      // 15. Composite bundle
      [
        { value: 0, name: "is_composite", label: "Produkt kompozit (paketë)", type: "checkbox-field", style: "min-width: 100%; margin-top: 8px;" },
      ],
      [
        {
          name: "composite_items",
          label: "Komponentët e paketës",
          type: "composite-items",
          style: "min-width: 100%",
          data: [],
          required: false,
          vif: [{ field: "is_composite", value_not: 0 }],
        },
      ],
      // 16. Delisto (end of card)
      [
        { value: 0, name: "delisted", label: "Delisto", type: "checkbox-field", style: "min-width: 20%; margin-top: 8px;" },
        { value: "", name: "delisted_reason", label: "Koment (pse po delistohet)", type: "text-field", style: "min-width: 70%", required: true, vif: [{ field: "delisted", value: 1 }] },
      ],
    ],
  };
}
